<template>
  <card header-classes="d-flex justify-content-between" body-classes="p-0" class="card-list">
    <!-- Card header -->
    <template slot="header">
      <h5 class="h3 mb-0 mr-3" slot="header">My Todos</h5>

      <div class="card__new">
        <div class="card__popup js-list-add-new" id="addTodoPopup">
          <form @submit.prevent="addTodo()">
            <div class="mb-3">
              <div class="has-label">
              <base-input label="Todo"
                          name="toDoText"
                          type="textarea"
                          placeholder="Todo"
                          rules="required"
                          v-model="model.toDoText">
              </base-input>
              </div>
            </div>

            <div class="mb-3">
              <span id="list-datetime-local-input">
                <fieldset id="list-group">
                  <div>
                    <div class="">
                      <base-input label="Date/Time"
                                  name="dueDate"
                                  type="date"
                                  rules="required"
                                  v-model="model.dueDate">
                      </base-input>
                    </div>
                  </div>
                </fieldset>
              </span>
            </div>

            <button type="submit" class="btn base-button btn-primary btn-sm">Add Todo</button>
          </form>
        </div><!-- /.card__popup -->
        <button class="btn base-button btn-primary btn-sm card__btn" data-target=".js-list-add-new" @click="popupHandler($event)">New Todo</button>
      </div><!-- /.card__new -->
    </template>
    <!-- Card body -->
    <b-list-group v-show="this.loading" class="loading">
      <b-list-group-item>
          <loading-panel></loading-panel>
      </b-list-group-item>
    </b-list-group>
    <b-list-group flush data-toggle="checklist" v-show="!this.loading">
      <b-list-group-item v-on:mouseover="setHover(item.id)" v-on:mouseleave="setHover(null)" class="checklist-entry flex-column align-items-start py-4 px-4"
          v-for="(item, index) in items"
          :key="index"
      >
        <div class="checklist-item"
            :class="item.isCompleted ? 'checklist-item-checked ichecklist-item-success' : 'checklist-item-info'">
          <div class="checklist-info">
            <h5 class="checklist-title mb-0">{{item.toDoText}}</h5>
            <small>{{ formatDate(item.dueDate) }}</small>
          </div>
          <div>
            <b-form-checkbox 
            v-model="item.isCompleted" 
            :class="`custom-checkbox-info`"
            v-on:input="toggleCompleted(item, item.isCompleted)"
            />
          </div>
          <div style="width:20px">
            <button type="button"
                    class="close"
                    v-show="checkHover(item.id)"
                    @click="deleteTodo(item, index)"
                    data-dismiss="modal"
                    aria-label="Delete">
              <span>×</span>
            </button>
          </div>
        </div>

      </b-list-group-item>
    </b-list-group>
  </card>
</template>
<script>
import uuid from 'uuid';
import { format, formatDistance, formatRelative, subDays } from 'date-fns'
import swal from 'sweetalert2';
import LoadingPanel from '@/components/LoadingPanel.vue';

export default {
  components: {
    LoadingPanel
  },
  data() {
    return {
      model: {
          id: '',
          toDoText: '',
          dueDate: '',
          isCompleted: false,
          isActive: true,
          userId: ''
        },
      hoverId: '',
      loading: true
    };
  },
  computed: {
    items() {
      let tempTodos = Object.values(this.$store.state.todos.myTodos)
      tempTodos.sort(this.sortByDate);
      return tempTodos;
    },
    isLoading() {
      return this.$store.state.todos.loading
    },
    user() {
      return this.$store.state.authentication.user.user;
    }
  },
  created() {
      this.getTodos();
  },
  methods: {
    setHover(id) {
      this.hoverId = id;
    },
    checkHover(id) {
      if ( id == this.hoverId ) {
        return true;
      } 
        return false;
    },
    sortByDate: function ( a, b ) {
      if ( a.dueDate < b.dueDate ){
        return -1;
      }
      if ( a.dueDate > b.dueDate ){
        return 1;
      }
      return 0;
    },
    toggleCompleted(todo, isCompleted) {
      const { dispatch } = this.$store;
      dispatch("todos/updateTodo",todo);
    
    },
    formatDate: function (date) {
      return format(date, 'MM/DD/YYYY')
    },
    popupHandler(event) {
      event.preventDefault();
      const targetClass = event.target.getAttribute('data-target');
      document.querySelector(targetClass).classList.toggle('is-visible');
    },
    closePopup() {
      const targetClass = document.getElementById('addTodoPopup');
      targetClass.classList.toggle('is-visible');
    },
    getTodos() {
      const { dispatch } = this.$store;
      dispatch("todos/getAllTodos");
    },
    deleteTodo(todo) {
      swal.fire({
        title: 'Delete Todo?',
        text: todo.toDoText,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes!',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
        const { dispatch } = this.$store;

        try {
              dispatch("todos/deleteTodo", todo.id)
                  .then(response => {
                    let itemIndex = this.items.findIndex(item => item.id == todo.id);
                    this.$store.state.todos.myTodos.splice(itemIndex, 1);
                      
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error:", error);
          }
        }


      });
    },
    addTodo() {
      if ( this.model.toDoText && this.model.toDoText != '' ) {
        this.model.id = uuid();
        this.model.userId = this.user.id;
        
        const { dispatch } = this.$store;
        dispatch("todos/addTodo", this.model).then(() => {
            this.getTodos();
            this.model.toDoText = '';
        });
        
        
        this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Todo Added'});
        this.closePopup();
      }
      
    },
    dateFormat(date) {
      var local = new Date(date);
      return local.toJSON().slice(0,10);
    }
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
    }
  }
};
</script>